import { render, staticRenderFns } from "./ChatroomMessageList.vue?vue&type=template&id=6003f34f&scoped=true&"
import script from "./ChatroomMessageList.vue?vue&type=script&lang=js&"
export * from "./ChatroomMessageList.vue?vue&type=script&lang=js&"
import style0 from "./ChatroomMessageList.vue?vue&type=style&index=0&id=6003f34f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6003f34f",
  null
  
)

export default component.exports